import { DropdownSelect, SelectItem, Tooltip } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';
import { ReactNode } from 'react';

import { SupportedCSATLanguageCode } from 'app/views/layout/views/settings/views/satisfaction/utils/supportedCSATLanguages/supportedCSATLanguages';

import { LanguageCodeItem } from '../../types';

type ConversationHeaderCsatDropdownProps = {
  /** Loading state for the dropdown */
  isLoading: boolean;
  /** Function to refresh rating info */
  onRefreshRatingInfo: () => void;
  /** The selected language code. */
  surveyLanguage: SupportedCSATLanguageCode | undefined;
  /** The language code items. */
  availableLanguageCodeItems: LanguageCodeItem[];
  /** Function to handle language select. */
  handleLanguageSelect: (language: LanguageCodeItem) => void;
  /** Function to handle cancel. */
  handleCancelCsat: () => void;
  /** Function to get the button display text. */
  buttonDisplayText: string;
  /** The button tooltip content. */
  tooltipContent: ReactNode;
};

export const ConversationHeaderCsatDropdown = ({
  isLoading,
  onRefreshRatingInfo,
  surveyLanguage,
  availableLanguageCodeItems,
  handleLanguageSelect,
  handleCancelCsat,
  buttonDisplayText,
  tooltipContent,
}: ConversationHeaderCsatDropdownProps): JSX.Element => {
  return (
    <Tooltip content={tooltipContent}>
      <DropdownSelect
        buttonProps={{
          icon: 'smile',
          isLoading: isLoading,
          variant: 'tertiary',
        }}
        items={availableLanguageCodeItems}
        itemComponent={SelectItem}
        selectedItems={surveyLanguage ? [surveyLanguage] : []}
        onSelect={handleLanguageSelect}
        onClear={handleCancelCsat}
        onClearText="Cancel survey"
        onToggle={(isOpen) => {
          if (isOpen) {
            ampli.conversationCsatMenuOpened();
            onRefreshRatingInfo();
          }
        }}
      >
        {buttonDisplayText}
      </DropdownSelect>
    </Tooltip>
  );
};
